import { ApiService } from "services/Api.service";
import { AccessTokenService } from "services/application/AccessToken.service";

export interface AuthServiceInterface {
  login({
    email,
    password
  }: {
    email: string;
    password: string;
  }): Promise<void>;
  logout(): Promise<void>;
}

export class AuthService implements AuthServiceInterface {
  private _apiService: ApiService;
  private _accessTokenService: AccessTokenService;

  constructor(apiService: ApiService, accessTokenService: AccessTokenService) {
    this._apiService = apiService;
    this._accessTokenService = accessTokenService;
  }

  public async login({ email, password }: { email: string; password: string }) {
    return await this._apiService
      .post<{ token: string }>("/overmind/auth/login", {
        emailAddress: email,
        password
      })
      .then(({ token }) => {
        this._accessTokenService.setAccessToken(token);
        window.location.href = "/";
      });
  }

  public logout() {
    return this._apiService.post("/overmind/auth/logout").then(() => {
      this._accessTokenService.setAccessToken(null);
      window.location.href = "/overmind/auth/login";
    });
  }
}
